/* Temporary overflow diagnostic. Only runs when the URL contains ?nproverflow=1. */
(function(){
  if (location.search.indexOf('nproverflow') === -1) return;
  function run(){
    var vw = document.documentElement.clientWidth;
    var list = [];
    document.querySelectorAll('body *').forEach(function(el){
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      if (r.right > vw + 2 || r.left < -2){
        var name = el.tagName.toLowerCase();
        var c = (el.className || '').toString().trim().split(/\s+/).slice(0,3).join('.');
        if (c) name += '.' + c;
        list.push(name + '  [L'+Math.round(r.left)+' R'+Math.round(r.right)+' w'+Math.round(r.width)+' '+cs.position+']');
      }
    });
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:100000;background:#A94F3C;color:#fff;font:11px/1.4 monospace;padding:10px;max-height:70vh;overflow:auto;white-space:pre-wrap;-webkit-user-select:text;user-select:text;';
    box.textContent = 'viewport=' + vw + '  documentScrollWidth=' + document.documentElement.scrollWidth +
      '\n(scrollWidth > viewport = horizontal overflow)\n\nELEMENTS PAST THE EDGE (' + list.length + '):\n' + list.slice(0,30).join('\n');
    document.body.appendChild(box);
  }
  if (document.readyState === 'complete') setTimeout(run, 800);
  else window.addEventListener('load', function(){ setTimeout(run, 800); });
})();
